import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Estado unificado cuando el complemento de firma local no responde o no está instalado.
 * Misma apariencia en firmar, administrar token, almacén y descargar certificado.
 */
@Component({
  selector: 'app-local-agent-unavailable-panel',
  templateUrl: './local-agent-unavailable-panel.component.html',
  styleUrls: ['./local-agent-unavailable-panel.component.css'],
  standalone: false
})
export class LocalAgentUnavailablePanelComponent {
  /** Mientras el padre comprueba salud del agente / lista inicial */
  @Input() loading = false;
  @Input() loadingMessage = 'Comprobando el complemento…';

  /** Etiqueta contextual (ej. "Firma con Certifirma Digital Físico"); opcional */
  @Input() featureTag = '';
  @Input() releaseLabel = '';

  /** Si no se indica, se usan textos genéricos unificados */
  @Input() title = '';
  @Input() message = '';

  /**
   * Texto del recuadro de ayuda. Vacío = texto estándar con "Actualizar" en negrita.
   * Puede ser un mensaje fijo sin HTML.
   */
  @Input() hint = '';

  /**
   * URL del instalador (http → enlace directo; ruta local → botón emite `obtain`).
   */
  @Input() downloadUrl = '';

  @Output() obtain = new EventEmitter<void>();
  @Output() refresh = new EventEmitter<void>();

  get resolvedTitle(): string {
    return (this.title || '').trim() || 'Complemento de firma no disponible';
  }

  get resolvedMessage(): string {
    return (
      (this.message || '').trim() ||
      'Instala y ejecuta el complemento de firma en este equipo. Es necesario para usar tokens USB y certificados del almacén local.'
    );
  }

  get useHttpLink(): boolean {
    return (this.downloadUrl || '').trim().startsWith('http');
  }

  get httpHref(): string {
    return this.downloadUrl.trim();
  }

  get showCustomHint(): boolean {
    return !!(this.hint || '').trim();
  }

  get resolvedReleaseLabel(): string {
    return (this.releaseLabel || '').trim() || `${environment.agentDisplayName} — ${environment.agentReleaseLabel}`;
  }

  get resolvedChecksum(): string {
    return (environment.agentChecksumSha256 || '').trim();
  }
}
